module.exports = __webpack_public_path__ + "img/cooperate07.45f85dc7.png";